import type { ReactNode } from 'react';

export const symbol_bottom_panel_close: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m501-548 89-89q7-7 3.46-16.5T580-663H380q-9.92 0-13.46 9.5Q363-644 370-637l89 89q9 9 21 9t21-9Zm279-292q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h600ZM180-327v147h600v-147H180Zm600-60v-393H180v393h600Zm-600 60v147-147Z"
		/>
	</svg>
);
